import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NgForm } from '@angular/forms';
import { DataService } from '../../../data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'angular-web-storage';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';

declare let $;
@Component({
  selector: 'app-withdrawal',
  templateUrl: './withdrawal.component.html',
  styleUrls: ['./withdrawal.component.scss'],
})
export class WithdrawalComponent implements OnInit {
  pwith: any;
  xrp: any;
  val: number;
  country: any;
  bank: any;
  amb: any;
  trust: any;
  withlimit: any;
  ether: any;
  usdtbep: any;
  usdterc: any;
  display = 0;
  usdttrc: any;
  upi: any;
  upis: any;
  upname: any;
  trust_access: any;

  constructor(
    private server: DataService,
    private cookieService: CookieService,
    private route: Router,
    private activate: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrManager,
    public session: SessionStorageService
  ) {
    if ($(".toggled")) {
      $("#tog").click();
    }

    $('.app-wrap').removeClass('sidebar-toggled');
  }

  cookieValue = this.cookieService.get('logID');
  acc;

  /*  showSuccess() {
    this.toastr.success('You are awesome!', 'Success!');
  } */

ngOnInit() {
  $('.pc-sidebar ').removeClass('mob-sidebar-active');
  $('.lay ').removeClass('pc-menu-overlay');

  this.cookieValue = this.session.get('sessionID');

  const data = this.activate.snapshot.data?.['news'];
  const dep = data?.dep;
  const msg = dep?.message?.[0];

  if (!msg) {
    console.warn('Resolver data missing:', data);
    return;
  }

  this.acc = msg.mainaccountbal;
  this.amb = msg.ambassador;
  this.trust = msg.trust_fund;
  this.xrp = msg.ripple;
  this.country = msg.country;
  this.bank = msg.bank;
  this.pwith = dep?.pwith;
  this.withlimit = msg.with_limit == '0' ? 30 : msg.with_limit;
  this.usdtbep = msg.usdtbepaddress;
  this.usdttrc = msg.usdttrcaddress;
  this.upi = msg.upiaddress;
  this.trust_access = msg.trust_access;
  this.upname = msg.upname;

  this.upis = data?.upi?.message?.[0]?.status;

  console.log(msg);
}

  withdraw(x: NgForm) {
    let amount = parseInt(x.value.withdraw);
    if (amount >= this.withlimit) {
      if (x.value.withdrawto == 'Bank') {
        if (this.bank == 'Not set' || this.bank == '' || this.bank == null) {
          this.toastr.infoToastr('Update your Bank address');
        } else {
          if (amount <= this.acc) {
            let me = {
              withdraw: amount,
              withdrawto: x.value.withdrawto,
              val: this.cookieValue,
              key: 'withdraw',
            };
            this.server.Api(me).subscribe(
              (res) => {
                if (res['code'] == 1) {
                  this.toastr.successToastr(res['message'], 'Security Center');

                  this.route.navigate(['/dashboard/dashcontent']);
                }
                if (res['code'] == 2) {
                  this.toastr.warningToastr(res['message'], 'Security Center');
                } else {
                  this.toastr.infoToastr(res['message']);
                }
              },
              () => {},
              () => {}
            );
          } else {
            this.toastr.infoToastr('You cant withdraw more than you balance');
          }
        }
      }

      if (x.value.withdrawto != 'Bank') {
        if (
          x.value.withdrawto == 'xrp' &&
          (this.xrp == 'Not set' || this.xrp == '' || this.xrp == null)
        ) {
          return this.toastr.infoToastr('Update your Bitcoin address');
        }

        if (
          x.value.withdrawto == 'USDT(TRC20)' &&
          (this.usdttrc == 'Not set' || this.usdttrc == '' || this.usdttrc == null)
        ) {
          return this.toastr.infoToastr('Update your Usdt(trc20) address');
        }

        if (amount <= this.acc) {
          let me = {
            withdraw: amount,
            withdrawto: x.value.withdrawto,
            withdrawfrom: x.value.withdrawfrom,
            val: this.cookieValue,
            key: 'withdraw',
          };
          this.server.Api(me).subscribe(
            (res) => {
              if (res['code'] == 1) {
                this.toastr.successToastr(res['message'], 'Security Center');

                this.route.navigate(['/dashboard/dashcontent']);
              }
              if (res['code'] == 2) {
                this.toastr.warningToastr(res['message'], 'Security Center');
              } else {
                this.toastr.infoToastr(res['message']);
              }
            },
            () => {},
            () => {}
          );
        } else {
          this.toastr.infoToastr('You cant withdraw more than you balance');
        }
      }
    } else {
      this.toastr.infoToastr('You cant withdraw less than' + this.withlimit);
    }
  }

  logOut() {
    $('#exampleModalLive').css('display', 'none');

    this.route.navigate(['/dashboard/dashcontent']);
  }

  withdrawAll() {
    if (
      confirm(
        'Are you sure you want to close this account? This action cannot be reversed.'
      )
    ) {
      console.log('Thing was saved to the database.');
    } else {
      console.log('Thing was not saved to the database.');
    }
  }
}
